module.exports = __webpack_public_path__ + "img/icon-tracking-bell.e7baf02c.svg";